<ng-template
  let-extraClass="extraClass"
  #topNav>
  <tidy-top-nav
    [class]="extraClass"
    [title]="'Scan Your Property'"
    [canGoBack]="'true'" />
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>


    @if (errorMessage) {
      <tidy-error-message
        [text]="errorMessage" />
    }

    <tidy-card style="padding-bottom: 0px">
      <tidy-row class="extra-bottom-padding vertical-align-center">
        <tidy-image
          [src]="'assets/svg/navigate-circle.svg'"
          class="header-size" />
        <tidy-text
          [header]="'Select Your Lot'" />
      </tidy-row>
      @if (isMobile) {
        <tidy-row class="extra-bottom-padding">
          <tidy-text
            [body]="'First, tap a corner of your lot and drag to the next one.'" />
        </tidy-row>
        <tidy-row class="extra-bottom-padding">
          <tidy-text
            [body]="'Once the first line is created, tap each corner of your lot.'" />
        </tidy-row>
        <tidy-row class="extra-bottom-padding">
          <tidy-text
            [body]="'To finish, <u><b>tap the screen and hold</b></u> on the last remaining corner.'" />
        </tidy-row>
      }
      @if (!isMobile) {
        <tidy-row class="extra-bottom-padding">
          <tidy-text
            [body]="'First, click a corner of your lot and drag to the next one.'" />
        </tidy-row>
        <tidy-row class="extra-bottom-padding">
          <tidy-text
            [body]="'Once the first line is created, click each corner of your lot.'" />
        </tidy-row>
        <tidy-row class="extra-bottom-padding">
          <tidy-text
            [body]="'To finish the selection, <u><b>double click</b></u> the last remaining corner.'" />
        </tidy-row>
      }
      <div style="margin-right: -15px; margin-left: -15px">
        <img [src]="mapToShow" id="map"/>
      </div>
    </tidy-card>

    <ng-container>
      <tidy-button
        [text]="'Looks Good'"
        [action]="boundSubmitSelection"
        class="primary"
        [disabled]="!showButtons" />
      <tidy-button
        [text]="'Retry'"
        [action]="boundResetAnotations"
        class="secondary"
        [disabled]="!showButtons" />
    </ng-container>

  </tidy-wrapper>
</ng-template>

<app-scroll-wrapper [templateContent]="content" />
